export default __webpack_public_path__ + "static/rfc-video-cover-331727f0f5edca329ecb6eaa32d9611d.png";